<div class="spinner" [class.spinner--inline]="inline">Laster</div>
